import api from './api'
const URL_BASE = process.env.REACT_APP_API

export const GetTokenApp = async () => {
  try {
    const req = await fetch(`${URL_BASE}/Usuario/TokenApp`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: `"${process.env.REACT_APP_KEYAPI}"`,
    })
    const json = await req.json()
    return json
  } catch (error) {
    return undefined
  }
}

export const LoginUsuario = async (token, value) => {
  try {
    const req = await fetch(`${URL_BASE}/Usuario/Login`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', Authorization: `Bearer ${token}` },
      body: `"${value}"`,
    })
    const json = await req.json()
    return json
  } catch (error) {
    return undefined
  }
}
export const RecuperarSenha = async (email) => {
  try {
    const req = await fetch(`${URL_BASE}/Usuario/RecuperarLogin`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(email),
    })
    const json = await req.json()
    return json
  } catch (error) {
    return undefined
  }
}
export const IsHashValido = async (hash) => {
  try {
    const req = await fetch(`${URL_BASE}/Usuario/IsHashValido`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(hash),
    })
    const json = await req.json()
    return json
  } catch (error) {
    return undefined
  }
}
export const AltSenha = async (values) => {
  try {
    const req = await fetch(`${URL_BASE}/Usuario/AltSenha`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(values),
    })
    const json = req.json()
    return json
  } catch (error) {
    return undefined
  }
}

//Usuario
export const UsuarioGet = async () => {
  try {
    const req = await api.post('/Usuario/GetAll')
    return req.data
  } catch (error) {
    return undefined
  }
}
export const UsuarioAddOrUpdate = async (values) => {
  try {
    const req = await api.post('/Usuario/AddOrUpdate', values)
    return req.data
  } catch (error) {
    return undefined
  }
}
export const UsuarioGetById = async (Id) => {
  try {
    const req = await api.get(`/Usuario/GetById?id=${Id}`)
    return req.data
  } catch (error) {
    return undefined
  }
}
export const UsuarioGetConvite = async (id) => {
  try {
    const req = await api.get(`/Usuario/GetConvite?id=${id}`)
    return req.data
  } catch (error) {
    return undefined
  }
}
//Conversa
export const ConversaGet = async (filters) => {
  try {
    const req = await api.post('/Conversa/GetByFilter', filters)
    return req.data
  } catch (error) {
    return undefined
  }
}
export const ConversaAddMsg = async (values) => {
  try {
    const req = await api.post('/Conversa/AddMsg', values)
    return req.data
  } catch (error) {
    console.error('ConversaAddMsg Error', error)
    return undefined
  }
}
export const ConversaGetById = async (Id) => {
  try {
    const req = await api.get(`/Conversa/GetById?id=${Id}`)
    return req.data
  } catch (error) {
    return undefined
  }
}

//Norma
export const NormaGet = async (filters) => {
  try {
    const req = await api.post('/Norma/GetByFilter', filters)
    return req.data
  } catch (error) {
    return undefined
  }
}
export const NormaAddOrUpdate = async (values) => {
  try {
    const req = await api.post('/Norma/AddOrUpdate', values)
    return req.data
  } catch (error) {
    return undefined
  }
}
export const NormaGetById = async (Id) => {
  try {
    const req = await api.get(`/Norma/GetById?id=${Id}`)
    return req.data
  } catch (error) {
    return undefined
  }
}

// Laboratorio

export const LaboratorioGet = async () => {
  try {
    const req = await api.get('/Laboratorio/GetAll')
    return req.data
  } catch (error) {
    return undefined
  }
}
export const LaboratorioAddOrUpdate = async (values) => {
  try {
    const req = await api.post('/Laboratorio/AddOrUpdate', values)
    return req.data
  } catch (error) {
    return undefined
  }
}
export const LaboratorioGetById = async (Id) => {
  try {
    const req = await api.get(`/Laboratorio/GetById?id=${Id}`)
    return req.data
  } catch (error) {
    return undefined
  }
}

//SysParametros
export const SysParametroGet = async () => {
  try {
    const req = await api.get(`/SysParametro/GetAll`)
    return req.data
  } catch (error) {
    return undefined
  }
}
export const SysParametroAddOrUpdate = async (values) => {
  try {
    const req = await api.post('/SysParametro/AddOrUpdate', values)
    return req.data
  } catch (error) {
    return undefined
  }
}
